import React from "react"
import cn from "classnames"
import "./SpinnerContainer.scss"

interface ISpinnerContainerProps {
  showSpinner: boolean
  className?: string
  spinnerClassName?: string
  children?: React.ReactNode
  aboveContent?: boolean
  fullScreen?: boolean
  minHeight?: number
  size?: number
  style?: React.CSSProperties
}

const SpinnerContainer = ({
  children,
  showSpinner,
  className,
  spinnerClassName,
  aboveContent,
  fullScreen,
  minHeight,
  size,
  style,
}: ISpinnerContainerProps) => {
  if (aboveContent) {
    return (
      <div
        className={cn(
          "spinner-container clearfix",
          className,
          fullScreen && "spinner-container--full-screen"
        )}
        style={{ ...style, minHeight }}
      >
        <div className={cn("child-wrapper")}>{children}</div>
        {showSpinner && <div className="overlay"></div>}
        {showSpinner && (
          <img
            className={cn("spinner", spinnerClassName)}
            style={size ? { width: size, height: size } : {}}
            src={"/images/multi-circle-spinner.gif"}
          />
        )}
      </div>
    )
  }
  return (
    <div className={cn("spinner-container clearfix", className)} style={{ minHeight }}>
      <div className={cn("child-wrapper", { hide: showSpinner })}>{children}</div>
      {showSpinner && (
        <img
          className={cn("spinner", spinnerClassName)}
          style={size ? { width: size, height: size } : {}}
          src={"/images/multi-circle-spinner.gif"}
        />
      )}
    </div>
  )
}

export default SpinnerContainer
